import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import DownloadsPage from "./pages/DownloadsPage";
import MaintenancePage from "./pages/MaintenancePage";

// ========================================
// MAINTENANCE MODE : mettre true pour activer, false pour désactiver
const MAINTENANCE_MODE = false;
// ========================================

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  const [showMaintenance, setShowMaintenance] = useState(MAINTENANCE_MODE);

  if (MAINTENANCE_MODE && showMaintenance) {
    return (
      <div className="App">
        <MaintenancePage onBypassed={() => setShowMaintenance(false)} />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/qui-suis-je" element={<AboutPage />} />
          <Route path="/prestations" element={<ServicesPage />} />
          <Route path="/prestations/:serviceId" element={<ServicesPage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/telechargements" element={<DownloadsPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
